import { Box, Text } from '@chakra-ui/react';
import styled from '@emotion/styled/macro';
import BlockContent from '@sanity/block-content-to-react';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

//region styled

const DescriptionWrapper = styled.div`
  position: relative;
`;

const InnerWrapper = styled.div``;

const DescriptionSectionWrapper = styled.div`
  &:not(:first-of-type) {
    margin-top: 50px;
  }
  ul {
    padding-left: 20px;
  }
`;

//endregion

const ProjectDescription: FC<{ project?: Project }> = ({ project }) => {
  const { t } = useTranslation('projects');

  return (
    <DescriptionWrapper>
      <InnerWrapper>
        <DescriptionSectionWrapper>
          <Text layerStyle="projects.projectDescription.sectionTitle" as="h2">
            {t('benefits')}
          </Text>
          <Box layerStyle="projects.projectDescription.descriptionText">
            <BlockContent blocks={project?.benefits} />
          </Box>
        </DescriptionSectionWrapper>
        <DescriptionSectionWrapper>
          <Text layerStyle="projects.projectDescription.sectionTitle" as="h2">
            {t('whyThisProject')}
          </Text>
          <Box layerStyle="projects.projectDescription.descriptionText">
            <BlockContent blocks={project?.whyThisProject} />
          </Box>
        </DescriptionSectionWrapper>
        <DescriptionSectionWrapper>
          <Text layerStyle="projects.projectDescription.sectionTitle" as="h2">
            {t('howItWorks')}
          </Text>
          <Box layerStyle="projects.projectDescription.descriptionText">
            <BlockContent blocks={project?.howItWorks} />
          </Box>
        </DescriptionSectionWrapper>
      </InnerWrapper>
    </DescriptionWrapper>
  );
};

export default ProjectDescription;
